"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarChartItem = exports.ApTrendChartWidget = void 0;
var React = require("react");
var theme_1 = require("../../../utils/theme");
var utils_1 = require("./utils");
var ApLoaderDefault_1 = require("../../ApLoaderDefault");
var ApLoaderText_1 = require("../../ApLoaderText");
var ApWidgetBigValue_1 = require("../ApWidgetBigValue");
var ApWidgetCard_1 = require("../ApWidgetCard");
var ApWidgetErrorMessage_1 = require("../ApWidgetErrorMessage");
var ApWidgetName_1 = require("../ApWidgetName");
var styles_1 = require("./styles");
var MIN_BAR_CHART_ITEMS_COUNT = 2;
var RESIZE_TIMEOUT_DELAY = 500;
var SMALL_FONT_THRESHOLD = 16;
var MEDIUM_FONT_THRESHOLD = 10;
var ApTrendChartWidget = /** @class */ (function (_super) {
    __extends(ApTrendChartWidget, _super);
    function ApTrendChartWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            height: styles_1.LINE_CHART_MIN_HEIGHT,
            width: 200,
        };
        _this.ref = React.createRef();
        _this.handleResize = function () {
            if (_this.resizeTimeoutHandle) {
                clearTimeout(_this.resizeTimeoutHandle);
            }
            _this.resizeTimeoutHandle = setTimeout(function () {
                _this.setChartWidth();
                _this.resizeTimeoutHandle = null;
            }, RESIZE_TIMEOUT_DELAY);
        };
        return _this;
    }
    ApTrendChartWidget.prototype.componentDidUpdate = function () {
        this.setChartWidth();
    };
    ApTrendChartWidget.prototype.componentDidMount = function () {
        this.setChartWidth();
        if (window) {
            window.addEventListener('resize', this.handleResize);
        }
    };
    ApTrendChartWidget.prototype.componentWillUnmount = function () {
        if (window) {
            window.removeEventListener('resize', this.handleResize);
        }
    };
    ApTrendChartWidget.prototype.render = function () {
        var _a = this.props, data = _a.data, dataError = _a.dataError, config = _a.config, props = __rest(_a, ["data", "dataError", "config"]);
        return (React.createElement(ApWidgetCard_1.ApWidgetCard, __assign({}, props),
            React.createElement(styles_1.StyledWidgetWrapper, null,
                config && (React.createElement(ApWidgetName_1.ApWidgetName, { name: config.name, iconType: config.iconType })),
                dataError ? (React.createElement(styles_1.StyledWidgetBody, null,
                    React.createElement(ApWidgetErrorMessage_1.ApWidgetErrorMessage, null))) : !data ? (React.createElement(styles_1.StyledWidgetBody, null,
                    React.createElement(ApLoaderDefault_1.ApLoaderDefault, { loaderText: function () { return React.createElement(ApLoaderText_1.ApLoaderText, null); } }))) : data.list.length > MIN_BAR_CHART_ITEMS_COUNT ? (this.renderLineChartContent(data)) : (this.renderBarChartContent(data)))));
    };
    ApTrendChartWidget.prototype.setChartWidth = function () {
        if (this.ref.current &&
            (this.ref.current.clientWidth !== this.state.width ||
                this.ref.current.clientHeight !== this.state.height)) {
            this.setState({
                height: this.ref.current.clientHeight,
                width: this.ref.current.clientWidth,
            });
        }
    };
    ApTrendChartWidget.prototype.getValueTextSize = function (value) {
        var isSmallText = value.length > SMALL_FONT_THRESHOLD - 1;
        var isMediumText = value.length > MEDIUM_FONT_THRESHOLD &&
            value.length < SMALL_FONT_THRESHOLD;
        return isSmallText ? 's' : isMediumText ? 'm' : 'l';
    };
    ApTrendChartWidget.prototype.renderBarChartContent = function (data) {
        var list = data.list, value = data.value;
        var values = list.map(function (_a) {
            var chartValue = _a.value;
            return chartValue;
        });
        var valueTextSize = this.getValueTextSize(value);
        var maxValue = Math.max.apply(Math, __spread(values));
        var yScale = utils_1.scaleLinear({
            domain: [0, maxValue],
            range: [0, 100],
        });
        return (React.createElement(styles_1.Wrapper, null,
            React.createElement(ApWidgetBigValue_1.ApWidgetBigValue, { size: valueTextSize }, value),
            React.createElement(styles_1.BarChartWrapper, null, list.map(function (_a, idx) {
                var name = _a.name, label = _a.label, chartValue = _a.value;
                return (React.createElement(exports.BarChartItem, { key: name + label, height: yScale(chartValue), name: name, label: label }));
            }))));
    };
    ApTrendChartWidget.prototype.renderLineChartContent = function (data) {
        var list = data.list, value = data.value;
        var _a = this.state, width = _a.width, height = _a.height;
        var chartHeight = Math.max(styles_1.LINE_CHART_MIN_HEIGHT, height);
        var values = list.map(function (_a) {
            var chartValue = _a.value;
            return chartValue;
        });
        var minValue = Math.min.apply(Math, __spread(values));
        var maxValue = Math.max.apply(Math, __spread(values));
        var valueTextSize = this.getValueTextSize(value);
        var yScale = utils_1.scaleLinear({
            domain: [minValue, maxValue],
            range: [chartHeight, 0],
        });
        var prevPoint;
        var lines = [];
        var circles = [];
        if (!width) {
            return null;
        }
        var sectionsCount = list.length - 1;
        var sectionWidth = (1 / sectionsCount) * 100;
        list.forEach(function (_a, idx) {
            var name = _a.name, chartValue = _a.value;
            var w = width || 0;
            var x2 = (w * idx) / sectionsCount;
            var y2 = yScale(chartValue);
            var line = !!prevPoint && (React.createElement(styles_1.Line, { key: name + idx, stroke: theme_1.colors.blue, x1: prevPoint.x, y1: prevPoint.y, x2: x2, y2: y2 }));
            var circle = (React.createElement(styles_1.Circle, { key: name + idx, fill: theme_1.colors.blue, cx: x2, cy: y2, r: "5" }));
            prevPoint = { x: x2, y: y2 };
            lines.push(line);
            circles.push(circle);
        });
        return (React.createElement(styles_1.Wrapper, null,
            React.createElement(ApWidgetBigValue_1.ApWidgetBigValue, { size: valueTextSize }, value),
            React.createElement(styles_1.ChartWrapper, null,
                React.createElement(styles_1.ChartBodyWrapper, { ref: this.ref },
                    React.createElement(styles_1.Svg, { viewBox: "0 0 " + width + " " + chartHeight },
                        lines,
                        circles),
                    list.map(function (_a, idx) {
                        var name = _a.name, chartValue = _a.value, label = _a.label;
                        return (React.createElement(styles_1.ChartItem, { key: name + label, x: idx * sectionWidth, y: yScale(chartValue) }, label));
                    })),
                React.createElement(styles_1.ChartBottomAxisWrapper, null, list.map(function (_a, idx) {
                    var name = _a.name, label = _a.label;
                    return (React.createElement(styles_1.ChartScaleItem, { key: name + label, x: idx * sectionWidth }, name));
                })))));
    };
    return ApTrendChartWidget;
}(React.Component));
exports.ApTrendChartWidget = ApTrendChartWidget;
exports.BarChartItem = function (_a) {
    var height = _a.height, name = _a.name, label = _a.label;
    return (React.createElement(styles_1.BarChartItemWrapper, null,
        React.createElement(styles_1.BarChartMarker, { height: height },
            React.createElement(styles_1.BarChartItemLabel, null, label),
            React.createElement(styles_1.BarChartItemName, null, name))));
};
//# sourceMappingURL=ApTrendChartWidget.js.map